import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, ChevronRight } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_803bb858-9c3b-4809-94a4-95fda83a66ba/artifacts/t2u1oa1z_REVOQUOTA.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const services = [
    { name: 'Linee Vita', href: '/servizi#linee-vita' },
    { name: 'Parapetti', href: '/servizi#parapetti' },
    { name: 'Progettazione', href: '/servizi#progettazione' },
    { name: 'Installazione', href: '/servizi#installazione' },
    { name: 'Revisione Periodica', href: '/servizi#revisione' },
  ];

  const company = [
    { name: 'Chi Siamo', href: '/chi-siamo' },
    { name: 'Gallery Progetti', href: '/gallery' },
    { name: 'Normative', href: '/normative' },
    { name: 'Blog', href: '/blog' },
    { name: 'Contatti', href: '/contatti' },
  ];

  const legal = [
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Cookie Policy', href: '/cookie-policy' },
    { name: 'Condizioni d\'Uso', href: '/privacy#condizioni' },
  ];

  return (
    <footer className="bg-revo-bg border-t border-revo-border">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          {/* Company Info */}
          <div className="lg:col-span-1">
            <Link to="/" data-testid="footer-logo">
              <img 
                src={LOGO_URL} 
                alt="RevoQuota" 
                className="h-12 w-auto mb-6"
              />
            </Link>
            <p className="font-manrope text-gray-400 text-sm leading-relaxed mb-6">
              Sistemi anticaduta e linee vita per la sicurezza dei lavori in quota. 
              Progettazione, installazione e revisione periodica certificata.
            </p>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-revo-orange mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-gray-300 text-sm">Via Alberto Dominutti, 6</p>
                  <p className="text-gray-400 text-sm">37135 Verona (VR)</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-revo-orange flex-shrink-0" />
                <a href="tel:800864621" className="text-gray-300 text-sm hover:text-revo-orange transition-colors">
                  800 86 46 21
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-revo-orange flex-shrink-0" />
                <a href="mailto:info@revoquota.com" className="text-gray-300 text-sm hover:text-revo-orange transition-colors">
                  info@revoquota.com
                </a>
              </div>
              <div className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-revo-orange mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-gray-300 text-sm">Lun - Ven: 8:30 - 18:00</p>
                  <p className="text-gray-400 text-sm">Sab: 9:00 - 12:00</p>
                </div>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-barlow text-white text-lg font-bold uppercase tracking-wide mb-6">
              Servizi
            </h3>
            <ul className="space-y-3">
              {services.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="group flex items-center gap-2 text-gray-400 hover:text-white transition-colors"
                    data-testid={`footer-link-${item.name.toLowerCase().replace(' ', '-')}`}
                  >
                    <ChevronRight className="w-4 h-4 text-revo-orange opacity-0 group-hover:opacity-100 transition-opacity" />
                    <span className="text-sm font-manrope">{item.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-barlow text-white text-lg font-bold uppercase tracking-wide mb-6">
              Azienda
            </h3>
            <ul className="space-y-3">
              {company.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="group flex items-center gap-2 text-gray-400 hover:text-white transition-colors"
                    data-testid={`footer-link-${item.name.toLowerCase().replace(' ', '-')}`}
                  >
                    <ChevronRight className="w-4 h-4 text-revo-orange opacity-0 group-hover:opacity-100 transition-opacity" />
                    <span className="text-sm font-manrope">{item.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter & Legal */}
          <div>
            <h3 className="font-barlow text-white text-lg font-bold uppercase tracking-wide mb-6">
              Resta Aggiornato
            </h3>
            <p className="text-gray-400 text-sm mb-4">
              Iscriviti per ricevere novità su normative e sicurezza.
            </p>
            <form className="flex gap-2 mb-8" data-testid="footer-newsletter-form">
              <input
                type="email"
                placeholder="La tua email"
                className="flex-1 bg-revo-paper border border-revo-border px-4 py-2 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-revo-orange transition-colors"
                data-testid="newsletter-email-input"
              />
              <button
                type="submit"
                className="bg-revo-orange text-white px-4 py-2 font-barlow font-bold text-sm uppercase tracking-wider hover:bg-revo-orange-dark transition-colors"
                data-testid="newsletter-submit-btn"
              >
                Iscriviti
              </button>
            </form>

            <h4 className="font-barlow text-white text-sm font-bold uppercase tracking-wide mb-4">
              Legal
            </h4>
            <ul className="space-y-2">
              {legal.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-gray-500 hover:text-gray-300 text-xs font-manrope transition-colors"
                    data-testid={`footer-legal-${item.name.toLowerCase().replace(' ', '-')}`}
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-revo-border">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-center md:text-left">
              <p className="text-gray-500 text-xs font-manrope">
                © {currentYear} <span className="text-gray-400">RevoQuota</span> - Un marchio di{' '}
                <span className="text-gray-300">Revogreen srl</span>
              </p>
              <p className="text-gray-600 text-xs mt-1">
                P.IVA 05121010234 | Via Alberto Dominutti, 6 - 37135 Verona (VR)
              </p>
            </div>
            <div className="flex items-center gap-6">
              <span className="text-gray-500 text-xs uppercase tracking-wider">
                Sicurezza Certificata
              </span>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 bg-revo-paper border border-revo-border flex items-center justify-center">
                  <span className="text-[10px] text-gray-400 font-bold">UNI</span>
                </div>
                <div className="w-8 h-8 bg-revo-paper border border-revo-border flex items-center justify-center">
                  <span className="text-[10px] text-gray-400 font-bold">EN</span>
                </div>
                <div className="w-8 h-8 bg-revo-paper border border-revo-border flex items-center justify-center">
                  <span className="text-[10px] text-gray-400 font-bold">795</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
